import { render, staticRenderFns } from "./StudioHome.vue?vue&type=template&id=29f4ecb8"
import script from "./StudioHome.vue?vue&type=script&lang=js"
export * from "./StudioHome.vue?vue&type=script&lang=js"
import style0 from "./StudioHome.vue?vue&type=style&index=0&id=29f4ecb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports